module.exports = __webpack_public_path__ + "ai.no2.9541abe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ai.no2.jpg
// module id = 6UHM
// module chunks = 0